export enum CancelModalViewState {
    CLOSED,
    LOADING,
    SELECT_REASON,
    SAVING,
    ERROR,
}

export const OTHER_OPTION = "Other";
